export const messageSlack = async (message: string) => {
  try {
    const response = await fetch("https://superwall-crm.herokuapp.com/slack", {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: message,
      }),
    })
    const data = await response.json()
    console.log("HTTP Request Succeeded: " + response.status)
    console.log("response", data)
  } catch (e) {
    /**
     * Just log error in console. Not critical if error occurs
     */
    console.log("HTTP Request Faild")
    console.log(e)
  }
}
